"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestERC20__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "DOMAIN_SEPARATOR",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "blocking",
                type: "bool",
            },
        ],
        name: "blockTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "blocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "permit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "ok",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class TestERC20__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.TestERC20__factory = TestERC20__factory;
TestERC20__factory.bytecode = _bytecode;
TestERC20__factory.abi = _abi;
//# sourceMappingURL=TestERC20__factory.js.map